import blocks from '~/queries/blocks'
import { pageContentQuery } from '~/queries/page-content/entry'
import { newsletterPageContentQuery } from '~/queries/page-content/newsletters'

export const useContentBuilder = () => {

    // if it doesn't exist here then it uses 'contentBuilder'
    const contentBuilderKeys = {
        'ds_Events_Entry': 'articleContentBuilder',
        'ds_NewsletterArticle_Entry': 'articleContentBuilder',
        'ds_News_Entry': 'articleContentBuilder',
        'ds_LayoutBlock_Entry': 'layout_contentBuilder',
        'ds_PreFooterLayout_Entry': 'preFooterLayout_ContentBuilder',
    }

    // generate a query string of the fragments
    const generateQuery = (usedBlocks, page) => {
        let contentQuery = ''
        let contentBuilderFragment = ''

        // loop over each content block and stitch together their queries
        forIn(usedBlocks, (blockQuery, blockKey) => {
            // add block to list of fragments to query
            contentQuery += blockQuery

            // generate contentBuilder part of the query
            contentBuilderFragment += `
                ... on ${blockKey} {
                    id
                    ...${blockKey}
                }
            `
        })

        const contentBuilderKey = get(contentBuilderKeys, page.__typename, 'contentBuilder')

        // get page content query from page type
        if (page.__typename === 'ds_Newsletter_Entry') {
            contentQuery += newsletterPageContentQuery(contentBuilderFragment)
        } else {
            contentQuery += pageContentQuery(page.__typename, contentBuilderKey, contentBuilderFragment)
        }

        return `${contentQuery}`
    }

    const queryContentBuilder = (page) => {
        // check for a page
        if (isNil(page)) {
            console.error('No page provided to queryContentBuilder')
            return
        }

        const contentBuilderKey = get(contentBuilderKeys, page.__typename, 'contentBuilder')

        // check if the page has a content builder
        if (isNil(page[contentBuilderKey])) {
            // console.warn('No contenteBuilder in entry')
            return null
        }

        const pageContentBuilderTypes = uniq(map(page[contentBuilderKey], (block) => {
            return block.__typename
        }))

        const pageBlocks = pick(blocks, pageContentBuilderTypes)

        return generateQuery(pageBlocks, {
            ...page,
            __typename: page.__typename || page.typename
        })
    }

    return {
        contentBuilderKeys,
        queryContentBuilder
    }
}